module.exports = __webpack_public_path__ + "static/cta-1-moc-1-a67f75afc878ae09a4fa193117d2b310.png";